module.exports = __webpack_public_path__ + "img/icon_tpo103.c61bacc1.svg";